import urlFile from "../common/ApiFile"
import url from "../common/api"
import {getQueries} from "../queries/getQueries.js"

export async function getPaysList(){
    var datas=[]
    await getQueries("pays").then(data=>{
        data.map((element)=>{
           datas= [...datas,{value:element.id,label:element.nom,unite_administratives:element.unite_administratives}]
        })
    })
    
    return await _.sortBy(datas,"label")
}

// export  getLangue